/**
 * Shared API utility helpers — type guards and response parsing shared
 * across all API call sites in the application.
 */

/** Narrows an unknown response value to an error shape returned by the Express API. */
export function isErrorResponse(value: unknown): value is { error: string } {
    return (
        typeof value === 'object' &&
        value !== null &&
        'error' in value &&
        typeof (value as { error?: unknown }).error === 'string'
    );
}
